import { RouteConfig } from 'vue-router';

const list: Array<RouteConfig> = [
  {
    path: 'load-balancers',
    name: 'computeLoadBalancers',
    component: () => import('@/self-service/pages/compute/loadBalancers'),
    props: true,
    meta: {
      title: $t => $t('Load balancers'),
    },
    children: [
      {
        path: 'add',
        name: 'computeLoadBalancersAdd',
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersAdd'),
        meta: {
          href: 'add',
          title: $t => $t('Create load balancer')
        },
        children: [
          {
            path: 'add-pool',
            name: 'computeLoadBalancersAddPool',
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersAddPool'),
            meta: {
              title: $t => $t('Create load balancer pool')
            },
            children: [
              {
                path: 'vms',
                name: 'computeLoadBalancersPoolVms',
                component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersPoolVms'),
              },
              {
                path: 'healthmonitor',
                name: 'computeLoadBalancersPoolMonitorParams',
                component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersMonitorParams'),
              }
            ]
          }
        ]
      },
      {
        path: ':loadBalancerId/:detailsTab(overview|properties)?',
        name: 'computeLoadBalancersDetails',
        meta: {
          title: $t => $t('Load balancers')
        },
      },
      {
        path: ':loadBalancerId/edit/:returnRoute?',
        name: 'computeLoadBalancersEdit',
        meta: {
          title: $t => $t('Edit load balancer')
        },
        props: true,
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersEdit'),
      },
    ]
  },
];

export default list;
